// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__16Ai1","title":"InfoRow_title__2j9Po"};